import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CameraDto } from '../../../../../../api/gen';
import { CameraService } from '../../../../../../api/gen/api/camera.service';
import { CameraEventsComponent } from '../camera-events/camera-events.component';
import { JJamesCardComponent } from 'shared-lib';

@Component({
    selector: 'app-camera-events-page',
    standalone: true,
    imports: [
        CommonModule,
        MatButtonModule,
        MatIconModule,
        MatProgressSpinnerModule,
        CameraEventsComponent,
        JJamesCardComponent
    ],
    templateUrl: './camera-events-page.component.html',
    styleUrl: './camera-events-page.component.scss'
})
export class CameraEventsPageComponent implements OnInit {
    private route = inject(ActivatedRoute);
    private cameraService = inject(CameraService);

    cameraId = signal<string | null>(null);
    camera = signal<CameraDto | null>(null);
    parkingSpaceId = signal<string | null>(null);
    isLoading = signal(false);

    ngOnInit(): void {
        this.route.params.subscribe(params => {
            const id = params['cameraId'];
            if (id) {
                this.cameraId.set(id);
                this.loadCamera(id);
            }
        });

        this.route.queryParams.subscribe(params => {
            this.parkingSpaceId.set(params['parkingSpaceId'] ?? null);
        });
    }

    private loadCamera(id: string): void {
        this.isLoading.set(true);
        this.cameraService.camerasCameraIdGet(id).subscribe({
            next: (camera) => {
                this.camera.set(camera);
                this.isLoading.set(false);
            },
            error: () => this.isLoading.set(false)
        });
    }

    goBack(): void {
        window.history.back();
    }
}
